import { Component, inject } from '@angular/core';
import { BackendApi } from '../../services/backend-api';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AgGridAngular } from "ag-grid-angular";
import type { AutoSizeStrategy, ColDef, GridReadyEvent } from "ag-grid-community";
import { AG_GRID_LOCALE_FR } from '@ag-grid-community/locale';
import { Area } from '../../models/area';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-list-areas',
  imports: [AgGridAngular, MatIconModule],
  templateUrl: './list-areas.html',
  styleUrl: './list-areas.css',
})
export class ListAreas {
  constructor(
    private readonly backendApi: BackendApi
  ) { }

  private _snackBar = inject(MatSnackBar);

  public autoSizeStrategy: AutoSizeStrategy = {
    type: 'fitGridWidth',
    defaultMinWidth: 100,
  };

  public columns: ColDef<Area>[] = [
    { field: "country.flag", headerName: "", filter: false, sortable: false, width: 100 },
    { field: "country.name_fr", headerName: "Pays", filter: true, floatingFilter: true },
    { field: "name", headerName: "Nom", filter: true, floatingFilter: true },
    { field: "is_landline", headerName: "Fixe / Mobile", cellDataType: false, valueFormatter: (params) => params.value ? 'Fixe' : 'Mobile' }
  ];

  public localeText = AG_GRID_LOCALE_FR;

  onGridReady(event: GridReadyEvent) {
    this.backendApi.getAreas().subscribe({
      next: (areas) => {
        event.api.setGridOption('loading', false);
        event.api.setGridOption('rowData', areas);
      },
      error: () => {
        // Error encountered
        event.api.setGridOption('loading', false);
        this._snackBar.open("Erreur rencontrée lors de la recuperation des areas.");
      }
    })
  }
}
